import styled from 'styled-components'

const SectionTitle = styled.h3<{ marginBottom?: string }>`
  margin: 0 0 10px;
  color: ${(p) => p.theme.FONT_COLOR};
  font-weight: 700;
  font-size: ${(p) => p.theme.font.size.xl};
  line-height: 30px;
  margin-bottom: ${(p) => p.marginBottom || '10px'};
`

export default SectionTitle
